<template lang="pug">
.event-date
  .dates(v-if="dateMode === 'dates'")
    .date(
      v-for="(date, $index) in filteredDates"
      :class="{ 'has-past': isPast(date) }"
      :key="$index"
    )
      span.next-label(v-if="dateMode === 'dates' && limit === 1 && filteredDates.length === 1") Next Meeting:
      span {{ date | date(format) }}
  span(v-else v-html="dateLabel")
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'event-date',
  computed: {
    dateLabel() {
      if (!this.filteredDates || this.filteredDates.length === 0) return 'This event is past';
      const separator = (this.dateMode === 'range') ? ' &ndash; ' : ' </br> ';
      return this.formattedDates.join(separator);
    },
    dateMode() {
      let mode = 'date';
      if (this.event.dates.length === 2) {
        mode = 'range';
      } else if (this.event.dates.length > 2) {
        mode = 'dates';
      }
      return mode;
    },
    event() {
      return this.value;
    },
    filteredDates() {
      let res = _.sortBy(this.event.dates);
      if (!this.filter) return res;
      const today = moment();
      if (this.dateMode !== 'range') {
        if (this.month) {
          const bom = moment(this.month, 'YYYY-MM-DD').startOf('month');
          const eom = moment(this.month, 'YYYY-MM-DD').endOf('month');
          res = _.filter(res, (str) => {
            const date = moment(str, 'YYYY-MM-DD');
            return date.isBetween(bom, eom, 'day', '[]');
          });
        }
        res = _.filter(res, (str) => {
          const date = moment(str, 'YYYY-MM-DD');
          return date.isSameOrAfter(today, 'day');
        });
      }
      if (this.limit > 0 && this.dateMode === 'dates') {
        res = res.splice(0, this.limit);
      }
      return res;
    },
    formattedDates() {
      return _.map(this.filteredDates, date => moment(date, 'YYYY-MM-DD').format(this.format));
    },
  },
  data() {
    return {};
  },
  methods: {
    isPast(date) {
      const today = moment();
      return moment(date, 'YYYY-MM-DD').isBefore(today, 'day');
    },
  },
  props: {
    filter: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: 'MM/DD/YYYY',
    },
    limit: {
      type: Number,
      default: 0,
    },
    month: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.event-date {
  .next-label {
    padding-right: 0.4rem;
  }
  .dates {
    .date {
      &.has-past {
        color: $grey-light;
        text-decoration: line-through;
      }
    }
  }
}
</style>
